var _circle, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 471,
    height: 466,
    viewBox: "0 0 471 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 221.001,
    cy: 283,
    r: 183,
    fill: "#F8F9FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.001,
    y: 304.912,
    width: 20.4209,
    height: 85.0872,
    rx: 3.5,
    fill: "#2F3037"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.652,
    y: 250.453,
    width: 20.4209,
    height: 139.543,
    rx: 3.5,
    fill: "#74767D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.297,
    y: 223.232,
    width: 20.4209,
    height: 166.771,
    rx: 3.5,
    fill: "#2F3037"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.948,
    y: 250.453,
    width: 20.4209,
    height: 139.543,
    rx: 3.5,
    fill: "#2F3037"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.599,
    y: 196,
    width: 20.4209,
    height: 193.999,
    rx: 3.5,
    fill: "#74767D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.001 143.923C326.001 103.823 358.409 71 398.001 71V143.923L348.797 197C334.8 184.023 326.001 164.987 326.001 143.923Z",
    fill: "#2F3037"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.093 143H468.803C468.803 161.796 461.136 179.407 449.015 192.205C435.684 206.202 416.699 215 396.093 215C377.112 215 359.738 207.408 346.403 195.405L396.093 143Z",
    fill: "#74767D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.001 143C470.001 103.407 437.594 71 398.001 71V143H470.001ZM362.002 71L390.802 135.8L326.002 107C332.41 90.2024 346.799 77.408 362.002 71Z",
    fill: "#D8D9E2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.768 37.179C313.846 39.219 311.124 40.5 308.097 40.5C302.279 40.5 297.563 35.799 297.563 30C297.563 24.201 302.279 19.5 308.097 19.5V0C291.547 0 278.001 13.503 278.001 30C278.001 46.497 291.547 60 308.097 60C316.79 60 324.646 56.334 330.001 50.502L315.768 37.179Z",
    fill: "#74767D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.001 0V19.5C313.8 19.5 318.501 24.201 318.501 30H338.001C338.001 13.503 324.498 0 308.001 0Z",
    fill: "#74767D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.098 30C318.098 33.407 316.494 36.4354 314.001 38.3908L326.263 54C333.401 48.4118 338.001 39.7493 338.001 30H318.098Z",
    fill: "#D8D9E2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0294 195.839C81.5538 198.273 85.1139 202.486 86.5505 207.848C89.3109 218.149 83.2237 228.731 72.9545 231.483C62.6853 234.235 52.1227 228.114 49.3623 217.812L14.8305 227.065C22.6832 256.372 53.0227 273.952 82.2366 266.124C111.451 258.296 128.935 227.901 121.082 198.595C116.957 183.201 106.738 171.028 93.8688 164.311L77.0294 195.839Z",
    fill: "#2F3037"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8756 227.234L49.4075 217.982C46.6558 207.712 52.75 197.157 63.0193 194.405L53.7665 159.873C24.5525 167.701 7.04776 198.02 14.8756 227.234Z",
    fill: "#74767D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2105 195.118C69.2438 193.501 75.3681 194.906 80.0134 198.392L101.837 169.271C88.5542 159.283 71.0312 155.246 53.7665 159.872L63.2105 195.118Z",
    fill: "#74767D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveAnalytics);
export default __webpack_public_path__ + "static/media/inactive-analytics.0a76c25e6a66a9675cc45aa642f2c70c.svg";
export { ForwardRef as ReactComponent };